/**
 * arrayUtils — generic array helpers.
 */

/**
 * Adds or updates an item in an array by key.
 * - If an item with the same key exists: replaces it in place (immutable).
 * - If not: prepends the item.
 *
 * @template T
 * @param {T[]} arr
 * @param {T} item
 * @param {string} [key='rk']
 * @returns {T[]}
 */
export function addOrUpdate(arr, item, key = 'rk') {
    const idx = arr.findIndex((r) => r[key] === item[key]);
    if (idx >= 0) {
        const next = [...arr];
        next[idx] = item;
        return next;
    }
    return [item, ...arr];
}
